import { render, staticRenderFns } from "./RegistrosLectoras.vue?vue&type=template&id=7088cfbf&"
import script from "./RegistrosLectoras.vue?vue&type=script&lang=js&"
export * from "./RegistrosLectoras.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosLectoras.vue?vue&type=style&index=0&id=7088cfbf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports